import "core-js/modules/es.date.now";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.to-string";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { objectToFormData } from 'object-to-formdata';
import { dateFormat, dateNow, dateOffset, getWxLocation, is, isUndef } from '@/lib/utils';
import { get, setex } from '@/lib/service/storage';
import { STORAGE_KEY } from '@/lib/constant';
var m = {
  state: function state() {
    return {
      timestamp: 0,
      requesting: 0,
      location: {
        id: 0,
        name: ''
      },
      adList: null,
      consultQrcode: null,
      useSafeArea: false,
      popup: {
        src: null,
        title: null,
        desc: null,
        desc2: null,
        neverDisplay: false,
        closeCb: null,
        actionText: null,
        actionCb: null,
        visible: false
      },
      district: {
        maxLevel: 3,
        modal: false,
        visible: false,
        update: null,
        finish: null
      },
      walletGoods: null,
      jssdkParamsExpireAt: null,
      upDataObj: {},
      wechatPopupVisible: false
    };
  },
  mutations: {
    setupdata: function setupdata(state, data) {
      state.upDataObj = data;
    },

    /**
     * 开始请求
     */
    startRequest: function startRequest(state) {
      state.requesting += 1;
    },

    /**
     * 结束一次请求
     */
    endRequest: function endRequest(state) {
      var count = state.requesting;
      state.requesting = Math.max(0, count - 1);
    },

    /**
     * 设置服务器时间戳
     */
    setServerTimestamp: function setServerTimestamp(state, timestamp) {
      state.timestamp = timestamp;
    },

    /**
     * 设置地址
     */
    setLocation: function setLocation(state, _a) {
      var location = _a.location,
          forceUpdate = _a.forceUpdate;
      state.location = location;

      if (location && forceUpdate) {
        setex(STORAGE_KEY.GET_CURRENT_LOCATION, JSON.stringify(location), dateFormat(dateOffset(dateNow(), 1)));
      }
    },

    /**
     * 记录ad
     */
    setUserCenterAd: function setUserCenterAd(state, adList) {
      state.adList = adList;
    },

    /**
     * 记录咨询二维码
     */
    setConsultQrCode: function setConsultQrCode(state, qrcode) {
      state.consultQrcode = qrcode;
    },
    setHistoryLength: function setHistoryLength(state, length) {
      state.useSafeArea = length === 1 && is.iPhoneXSeries();
    },

    /**
     * 记录二维码是否可见
     */
    setPopupVisible: function setPopupVisible(state, visible) {
      state.popup.visible = visible;
    },

    /**
     * 设置二维码内容
     *
     * @param {} src
     * @param {} title
     * @param {} desc
     */
    setPopupContent: function setPopupContent(state, _a) {
      var src = _a.src,
          title = _a.title,
          desc = _a.desc,
          desc2 = _a.desc2,
          actionText = _a.actionText,
          actionCb = _a.actionCb,
          neverDisplay = _a.neverDisplay,
          cb = _a.cb;
      var popup = state.popup;
      popup.src = src;
      popup.title = title;
      popup.desc = desc;
      popup.desc2 = desc2;
      popup.neverDisplay = neverDisplay;
      popup.closeCb = cb;
      popup.actionText = actionText;
      popup.actionCb = actionCb;
    },

    /**
     * 记录address的popup
     */
    setDistrictPopup: function setDistrictPopup(state, _a) {
      var maxLevel = _a.maxLevel,
          visible = _a.visible,
          modal = _a.modal,
          update = _a.update,
          finish = _a.finish,
          level2 = _a.level2;
      var district = state.district;
      district.maxLevel = maxLevel || 3;
      district.visible = visible;
      district.level2 = level2;
      district.modal = modal || false;
      district.update = update;
      district.finish = finish;
    },

    /**
     * 关闭地址弹窗
     */
    closeDistrictPopup: function closeDistrictPopup(state) {
      state.district.maxLevel = 3;
      state.district.visible = false;
      state.district.modal = false;
      state.district.update = null;
      state.district.finish = null;
    },

    /**
     * 设置余额换购商品
     */
    setWalletGoods: function setWalletGoods(state, goods) {
      state.walletGoods = goods;
    },

    /**
     * 记录jssdk参数的过期时间
     */
    setJSSDKParamsExpireAt: function setJSSDKParamsExpireAt(state, expireAt) {
      state.jssdkParamsExpireAt = expireAt;
    },
    setWechatPopupVisible: function setWechatPopupVisible(state, visible) {
      state.wechatPopupVisible = visible;
    }
  },
  actions: {
    /**
     * 图片上传
     *
     * @param {String} mediaId
     * @param {String} type
     * @param file 如果使用file需要使用FormData方式发送数据
     *
     * @return {Object} rdata
     *  - status 0表示成功，-1表示失败
     *  - message 失败信息
     */
    uploadMedia: function uploadMedia(_a, _b) {
      var commit = _a.commit;
      var mediaId = _b.mediaId,
          file = _b.file,
          type = _b.type,
          square = _b.square;
      return __awaiter(this, void 0, void 0, function () {
        var data, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              data = null;

              if (isUndef(file)) {
                data = {
                  media_id: mediaId,
                  type: type,
                  square: square
                };
              } else {
                data = objectToFormData({
                  file: file,
                  type: type,
                  square: square
                });
              }

              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/framework/upload_image', data)];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status !== 0) {
                _Toast(rdata.message || '上传错误');
              }

              commit('setupdata', rdata.data);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得jssdk参数
     *
     * @param {} url 链接
     * @param {} forceUpdate 是否强制更新
     */
    getJSSDKParams: function getJSSDKParams(_a, _b) {
      var state = _a.state,
          rootState = _a.rootState,
          commit = _a.commit;
      var url = _b.url,
          forceUpdate = _b.forceUpdate;

      if (!rootState.jssdk._cacheJSSDKParams || forceUpdate || !state.jssdkParamsExpireAt || state.jssdkParamsExpireAt < Date.now()) {
        return Vue.axios.get("/api/v1/framework/js_sdk_config?url=" + url).then(function (response) {
          var rdata = response.data;

          if (rdata.status === 0) {
            var jssdk = rdata.data;
            commit('setJSSDKParams', jssdk);
            commit('cacheJSSDKParams', true); // 设置过期时间为30分钟

            commit('setJSSDKParamsExpireAt', Date.now() + 30 * 60 * 1000);
            return jssdk;
          }
        });
      } else {
        return rootState.jssdk.jssdkParams;
      }
    },

    /**
     * 获取定位
     */
    getLocation: function getLocation(context, forceUpdate) {
      if (forceUpdate === void 0) {
        forceUpdate = false;
      }

      return __awaiter(this, void 0, Promise, function () {
        var currentLocation, location, response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!forceUpdate) {
                currentLocation = get(STORAGE_KEY.GET_CURRENT_LOCATION);

                if (currentLocation) {
                  context.commit('setLocation', {
                    location: JSON.parse(currentLocation),
                    forceUpdate: false
                  });
                  return [2
                  /*return*/
                  , true];
                }
              }

              return [4
              /*yield*/
              , getWxLocation()];

            case 1:
              location = _a.sent();

              if (!location) {
                return [2
                /*return*/
                , false];
              }

              if (!(location.status === 'success' && location.res)) return [3
              /*break*/
              , 3];
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/framework/decode_geo_location', {
                params: {
                  latitude: location.res.latitude,
                  longitude: location.res.longitude
                }
              })];

            case 2:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                if (rdata.data) {
                  context.commit('setLocation', {
                    location: rdata.data,
                    forceUpdate: true
                  });
                }
              } else {
                _Toast(rdata.message);
              }

              return [2
              /*return*/
              , rdata];

            case 3:
              if (forceUpdate) {
                // 社区那边要这样提示…
                _Toast('请在手机设置中允许微信使用GPS定位');
              }

              return [2
              /*return*/
              , false];
          }
        });
      });
    },

    /**
     * 获取个人中心广告
     */
    getUserCenterAd: function getUserCenterAd(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/framework/user_center_ads')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setUserCenterAd', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得咨询二维码
     */
    getConsultQrCode: function getConsultQrCode(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (state.consultQrcode) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/staff_qr_code')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setConsultQrCode', rdata.data.qr_code);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取商城登录信息
     */
    getStoreJwt: function getStoreJwt(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/store/login')];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取换购商品信息
     */
    getWalletGoods: function getWalletGoods(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var forceUpdate = (_b === void 0 ? {} : _b).forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.walletGoods && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/framework/wallet_goods')];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setWalletGoods', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;